(function () {
    'use strict';

    angular.module("imApp").factory("jobQueueMonitorService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1723,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
